import { render, staticRenderFns } from "./assignedCourses.vue?vue&type=template&id=c22993c4&"
import script from "./assignedCourses.vue?vue&type=script&lang=js&"
export * from "./assignedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports